import React, { useState } from 'react';
import { IoMdArrowBack } from "react-icons/io";
import './Enrollment.css';
import { useNavigate } from "react-router-dom";
import { TbPhotoUp } from "react-icons/tb";
import playStoreImg from "../../../assets/img/playstore.png"

const EnrollmentForm = () => {
  const [fileName, setFileName] = useState("No file chosen");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [fisrtName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [employeesCount, setEmployeesCount] = useState("");
  const [sitesCount, setSitesCount] = useState("");
  const [uploadPhoto, setUplaodPhoto] = useState(null);
  const navigate = useNavigate();




  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileName(file ? file.name : "No file chosen");
  };

  const goToPage = () => {
    navigate("/preferred_shop");
  };

  return (
    <>
      <div style={{height:"100vh", width:"100%", display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column", textAlign:"center"}}>
        <a href='https://play.google.com/store/apps/details?id=com.sintex.salesNew&hl=en_IN'>
        <img src={playStoreImg} style={{height:"80px", cursor:"pointer"}}/>
        <p>Tap here to download the app</p>
        <p> and get started!</p>
        </a>
      </div>
      {/* <div className="header">
        <h3 className="header-title">New User Registration</h3>
      </div>

      <div className="form-container">
        <div className="form-box">
          <h3 className="header-title">Basic Details</h3>
          <br />
          <div className="input-group">
            <input className="input-field" placeholder="First Name*" />
            <input className="input-field" placeholder="Last Name*" />
            <input className="input-field" placeholder="Mobile Number*" />
            <input className="input-field" placeholder="Current Address*" />
            <input className="input-field" placeholder="Number of Permanent Employees*" />
            <input className="input-field" placeholder="Number of Concurrent Sites*" />

            <div className="file-upload">
              <input 
                type="file" 
                id="fileInput1" 
                className="file-input" 
                onChange={handleFileChange} 
              />
              <label htmlFor="fileInput1" className="file-label">
                Upload Profile Pic*
              </label>
              <TbPhotoUp style={{fontSize:"30px", color:"white"}}/>
            </div>

            <select 
              className="dropdown" 
              value={selectedState} 
              onChange={(e) => setSelectedState(e.target.value)}
            >
              <option value="">Current State*</option>
              <option value="Maharashtra">Maharashtra</option>
              <option value="Delhi">Delhi</option>
              <option value="Karnataka">Karnataka</option>
            </select>

            <select 
              className="dropdown" 
              value={selectedCity} 
              onChange={(e) => setSelectedCity(e.target.value)}
              disabled={!selectedState}
            >
              <option value="">Current City*</option>
              {selectedState === "Maharashtra" && (
                <>
                  <option value="Mumbai">Mumbai</option>
                  <option value="Pune">Pune</option>
                </>
              )}
              {selectedState === "Delhi" && (
                <>
                  <option value="New Delhi">New Delhi</option>
                  <option value="South Delhi">South Delhi</option>
                </>
              )}
              {selectedState === "Karnataka" && (
                <>
                  <option value="Bangalore">Bangalore</option>
                  <option value="Mysore">Mysore</option>
                </>
              )}
            </select>

            <div className="radio-group">
              <label>
                <input 
                  type="radio" 
                  name="role" 
                  value="Plumber" 
                  checked={selectedRole === "Plumber"} 
                  onChange={(e) => setSelectedRole(e.target.value)} 
                /> Plumber
              </label>

              <label>
                <input 
                  type="radio" 
                  name="role" 
                  value="Plumbing" 
                  checked={selectedRole === "Plumbing"} 
                  onChange={(e) => setSelectedRole(e.target.value)} 
                /> Plumbing Contractor
              </label>
            </div>



            <button className='btn-class' onClick={goToPage}>Next</button>

          </div>
        </div>
      </div> */}
    </>
  );
}

export default EnrollmentForm;
